import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            d="M12 5.177l8.631 15.823h-17.262l8.631-15.823zm0-4.177l-12 22h24l-12-22zm-1 9h2v6h-2v-6zm1 9.75c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25z"
        />
    </svg>
)
